import React, { useContext } from 'react';
import clsx from 'clsx';
import { AppLayoutContext } from './context';
import styles from './styles.css.js';
export default function Background() {
    var contentType = useContext(AppLayoutContext).contentType;
    return React.createElement("div", { className: clsx(styles.background, 'awsui-context-content-header'), "data-content-type": contentType });
}
